'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { Ref } from 'react';
import { useState } from 'react';
import { RecentSearchChips, SearchBar, useHideOnScroll } from '@/app/_components/SearchBar';
import type { SearchScope } from '@/app/_components/SearchBar/constants';
const preventBlur = (e: React.MouseEvent) => e.preventDefault();
interface SearchPageHeaderProps {
  keyword: string;
  filterCount: number;
  recentKeywords: string[];
  scope?: SearchScope;
  onSearch: (keyword: string) => void;
  onFilterClick?: () => void;
  onSelectRecent: (keyword: string) => void;
  onRemoveRecent: (keyword: string) => void;
  onClearRecent: () => void;
  ref?: Ref<HTMLDivElement>;
}

/**
 * 모바일: `position: fixed` 오버레이로 상단 고정 + 스크롤 방향에 따라 translate 숨김.
 * PC: 일반 flow. spacer는 mobile-only.
 * ref는 외부 wrapper에 연결되어 IntersectionObserver의 관찰 대상이 된다
 * (모바일에서는 spacer 높이 = in-flow 기준으로 가시성을 판단).
 */
export const SearchPageHeader = t0 => {
  const $ = _c(26);
  const {
    keyword,
    filterCount,
    recentKeywords,
    scope,
    onSearch,
    onFilterClick,
    onSelectRecent,
    onRemoveRecent,
    onClearRecent,
    ref
  } = t0;
  const [isFocused, setIsFocused] = useState(false);
  const {
    hidden,
    atTop
  } = useHideOnScroll();
  const shouldHide = hidden && !isFocused;
  const shouldHideChipsOnMobile = !isFocused && !atTop;
  const t1 = shouldHide && "mobile-tablet:-translate-y-full";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex w-full flex-col items-center gap-12 bg-Gray-white", "mobile-tablet:fixed mobile-tablet:inset-x-0 mobile-tablet:top-0 mobile-tablet:z-10 mobile-tablet:gap-0", "mobile-tablet:transition-transform mobile-tablet:duration-200", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== filterCount || $[3] !== keyword || $[4] !== onFilterClick || $[5] !== onSearch || $[6] !== scope) {
    t3 = <SearchBar keyword={keyword} filterCount={filterCount} sticky={false} scope={scope} onSearch={onSearch} onFilterClick={onFilterClick} onFocusChange={setIsFocused} />;
    $[2] = filterCount;
    $[3] = keyword;
    $[4] = onFilterClick;
    $[5] = onSearch;
    $[6] = scope;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onClearRecent || $[9] !== onRemoveRecent || $[10] !== onSelectRecent || $[11] !== recentKeywords || $[12] !== shouldHideChipsOnMobile) {
    t4 = recentKeywords.length > 0 && <div className={cn("w-full overflow-hidden", "mobile-tablet:transition-[max-height] mobile-tablet:duration-200 mobile-tablet:ease-out", shouldHideChipsOnMobile ? "mobile-tablet:max-h-0" : "mobile-tablet:max-h-48")} onMouseDown={preventBlur}><RecentSearchChips keywords={recentKeywords} onSelect={onSelectRecent} onRemove={onRemoveRecent} onClearAll={onClearRecent} /></div>;
    $[8] = onClearRecent;
    $[9] = onRemoveRecent;
    $[10] = onSelectRecent;
    $[11] = recentKeywords;
    $[12] = shouldHideChipsOnMobile;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const t6 = recentKeywords.length > 0 && !shouldHideChipsOnMobile ? "mobile-tablet:h-88" : "mobile-tablet:h-48";
  let t7;
  if ($[18] !== t6) {
    t7 = cn("hidden mobile-tablet:block mobile-tablet:transition-[height] mobile-tablet:duration-200", t6);
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t7) {
    t8 = <div aria-hidden={true} className={t7} />;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== ref || $[23] !== t5 || $[24] !== t8) {
    t9 = <div ref={ref} className="w-full flex-1">{t5}{t8}</div>;
    $[22] = ref;
    $[23] = t5;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};